import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useDartInAppFlutter, useModal } from '~/hooks';
import { isInApp } from '~/utils';
import { GAEvent } from '~/utils';
import { airbridgeEvent } from '~/utils/airbridge';
import { GA } from '~/constants';
import { useUserStore } from '~/store';
import useToast from '~/store/useToast';
import dartKey from './dartKey';

const usePurchaseDart = () => {
  const queryClient = useQueryClient();
  const email = useUserStore((state) => state.email);

  const { openModal } = useModal();
  const { showToast } = useToast();

  const { callFlutterHandler, isVerifying } = useDartInAppFlutter(email, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: dartKey.getDarts(),
      });
      showToast('success', 'Purchase successful!');
    },
    onError: (error) => {
      showToast('error', error || 'Failed to purchase.');
    },
    onCancel: () => {
      showToast('error', 'Purchase canceled.');
    },
  });

  const handlePurchase = useCallback(
    (id: string, count: number, price: number) => {
      // 다트 구매 버튼 클릭
      const dartPurchaseEventData = {
        product_id: id,
        product_name: String(count), // 현재는 다트 갯수를 상품명으로 취급
        product_price: String(price),
      };
      // send GA event : CLICK_BUY_DART
      GAEvent(email, GA.ACTION.CLICK_BUY_DART, dartPurchaseEventData);
      airbridgeEvent.purchaseDart(email, {
        ...dartPurchaseEventData,
        product_price: price,
        product_quantity: count,
        currency: 'USD',
        inapp_purchased: true,
        status: 'clickBuyDart',
      });

      if (!isInApp()) {
        return openModal({
          title: 'Buy in App',
          content: 'You can buy on Hey.D App!',
          click: () => window.open('https://app.hey-d.ai/app', '_blank'),
          buttonName: 'Download',
        });
      }
      // 결제창 띄움
      callFlutterHandler({
        id,
        price,
        count,
      });
    },
    [callFlutterHandler, email, openModal],
  );

  return {
    handlePurchase,
    isVerifying,
  };
};

export default usePurchaseDart;
